import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { getRelatedCronosEvmChain } from '@cronos-app/sdk';
import { getSDK } from '@ui/utils/getSDK';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getUSDCToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.USDC,
    symbol: 'USDC',
    addressL1: sdks.L1.getContractAddress('USDC'),
    addressL2: sdks.L2.getContractAddress('USDC'),
    addressCronosEvm: getSDK(
      getRelatedCronosEvmChain(desiredNetwork),
    ).getContractAddress('USDC'),
    decimals: 6,
    displayDecimals: 2,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/usdc.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="usdc"
        {...props}
      />
    ),
  };
};
